import { useEffect, useState } from "react"
import type { HandLandmarker } from "@mediapipe/tasks-vision"

import { ensureHandLandmarker } from "../lib/hand-landmarker"

/**
 * Subscribe to the shared, session-cached MediaPipe hand-landmarker. The model
 * is created once (see `ensureHandLandmarker`) and reused, so mounting this in a
 * palm step after the quiz warmed it up resolves immediately. Does not close the
 * instance on unmount — the singleton outlives any single screen.
 */
export function useHandLandmarker() {
  const [landmarker, setLandmarker] = useState<HandLandmarker | null>(null)

  useEffect(() => {
    let mounted = true
    ensureHandLandmarker()
      .then((lm) => {
        if (mounted) setLandmarker(lm)
      })
      .catch(() => {})
    return () => {
      mounted = false
    }
  }, [])

  return { landmarker, ready: landmarker !== null }
}
